import { useFetch } from './fetch';

export const useProductImage = (id: string | null) => {
  const { isLoading, serverError, apiData } = useFetch(
    'GET',
    `${process.env.REACT_APP_BACKEND_API_URL}/images/${id}`,
    {},
  );

  return {
    isLoading,
    productImage: apiData as any,
    serverError,
  };
};
